import React, { Component } from 'react';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux'
import { FormattedHTMLMessage } from 'react-intl';

import Header from './Header.js';
import generateValidator from './Validations/generateValidator.js';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import CustomSpinner from './CustomSpinner.js';
import FlowProgressBar from './FlowProgressBar.js';
import FieldWrapper from './FieldWrapper.js';
import CarAsPaymentPlate from './CarAsPaymentPlate.js';
import CarAsPaymentModel from './CarAsPaymentModelCarQuote.js';
import CarAsPaymentQuote from './CarAsPaymentQuote.js';


class CarAsPayment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            hasCar: false,
            child: false,
            showContinueButton: false,
            carDetails: {
                car_price: null,
                car_model: null
            },
            selectedButton: null,
            selectedChildButton: null,
        };
        this.handleChildComponent = this.handleChildComponent.bind(this);
        this.setCarDetails = this.setCarDetails.bind(this);
    }

    handleHasCar(value) {
        const { dispatch, form } = this.props;
        if (value === '0') {
            // Temporarily skip plate option - go directly to model flow
            this.setState({ showContinueButton: false, hasCar: true, selectedButton: 'yes', child: 'model', selectedChildButton: 'model' })
            dispatch(change(form, 'used_car', value));
        } else {
            this.setState({ showContinueButton: true, hasCar: false, selectedButton: 'no', selectedChildButton: null })
            dispatch(change(form, 'used_car', value));
        }
    }

    handleChildComponent(value) {
        if (value === 'plate' || value === 'model') {
            this.setState({
                child: value,
                selectedChildButton: value,
            });
        } else {
            this.setState({ child: value });
        }
    };

    setCarDetails(carDetails) {
        this.setState({ carDetails: carDetails });
    }

    render() {
        const { handleSubmit, submitting, isLoading, dispatch } = this.props;
        const { hasCar, child, showContinueButton, selectedButton, selectedChildButton } = this.state;

        const childComponents = {
            'plate': CarAsPaymentPlate,
            'model': CarAsPaymentModel,
            'quote': CarAsPaymentQuote
        };

        const ChildComponent = childComponents[child];

        const dependent_children_field = (
            <div>
                <div className="car-payment-info">
                    <FormattedHTMLMessage id="app.step_car_as_payment_info" description="Used car as payment info" />
                </div>
                <button type="button" onClick={() => this.handleChildComponent('plate')} className={`pd-button-option ${selectedChildButton === 'plate' ? 'pd-btn-selected' : ''}`} disabled={submitting}>Patente</button>
                <button type="button" onClick={() => this.handleChildComponent('model')} className={`pd-button-option ${selectedChildButton === 'model' ? 'pd-btn-selected' : ''}`} disabled={submitting}>Modelo</button>
            </div>
        );

        return (
            <Section className="intro_form">
                <div className="row">
                    <Header>
                        <FlowProgressBar />
                    </Header>
                    <div className='container no-gutters'>
                        <form onSubmit={handleSubmit(this.props.saveCarUsed)} autoComplete="asd">
                            <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                                <div className='pvc-form'>
                                    <div className="car-payment-info">
                                        <FormattedHTMLMessage id="app.step_car_as_payment" description="Used car as payment info" />
                                    </div>
                                    {(isLoading || this.state.isLoading) && <CustomSpinner message='Estamos buscando tu auto ideal' />}
                                    <FieldWrapper>
                                        <button type="button" onClick={() => this.handleHasCar('0')} className={`pd-button-option ${selectedButton === 'yes' ? 'pd-btn-selected' : ''}`} disabled={submitting}>SI</button>
                                        <button type="button" onClick={() => this.handleHasCar('1')} className={`pd-button-option ${selectedButton === 'no' ? 'pd-btn-selected' : ''}`} disabled={submitting}>NO</button>
                                    </FieldWrapper>
                                    {hasCar && !child && dependent_children_field}
                                    {(hasCar && ChildComponent) &&
                                        <div className="pvc-form">
                                            <ChildComponent
                                                handleChildComponent={this.handleChildComponent}
                                                setCarDetails={this.setCarDetails}
                                                carDetails={this.state.carDetails}
                                                dispatch={dispatch} />
                                        </div>}
                                    {showContinueButton &&
                                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}


const selector = formValueSelector('CarAsPaymentForm')

CarAsPayment = connect(
    state => {
        const plate = selector(state, 'plate')
        return {
            plate,
        }
    }
)(CarAsPayment)


CarAsPayment = TopScrolleable(CarAsPayment);
let validate = generateValidator([{ name: 'usedCar', required: true }]);

CarAsPayment = reduxForm({
    form: 'CarAsPaymentForm', // a unique name for this form
    validate,
})(CarAsPayment);

CarAsPayment = withAuthControl(CarAsPayment);

export default CarAsPayment;



/** WEBPACK FOOTER **
 ** ./src/components/CarAsPayment.js
 **/